import { Component, ElementRef, ViewChild } from '@angular/core';
import { FiltersM, typesApex } from '../../../components/models';
import { formatear } from '../../funciones/funcionesGenerales';
import { DataService } from '../../../services/data/data.service';
import { ComercialService, PERIODICITY, PerspectiveIdentifier } from '../../../services/comercial/comercial.service';
import { firstValueFrom } from 'rxjs';
import { Meses } from '../../../models/Formulacion/indicadores-metas/datos';
import { TranslateService } from '@ngx-translate/core';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';
import { FormaterNumberPipe } from '../../../services/pipes/formater-number.pipe';
import { Header } from '../../../components/contenedor-elementos/interfaces/header.interface';

@Component({
  selector: 'app-indicadores-a1',
  templateUrl: './indicadores-a1.component.html',
  styleUrl: './indicadores-a1.component.css',
  providers: [FormaterNumberPipe]
})
export class IndicadoresA1Component {
  Filters = FiltersM;
  periodos = [];
  month = 'Enero';
  selectAllSucursales = true;
  sucursales = [];
  // Chips propios de "Región" (no usan el mecanismo de app-filters, que se deja intacto).
  @ViewChild('chipsRegionViewport') chipsRegionViewport?: ElementRef<HTMLDivElement>;
  sucursalesChipsVisibles: any[] = [];
  hayMasSucursalesSeleccionadas = false;
  get sucursalesSeleccionadas(): any[] {
    return this.sucursales.filter(s => s.check);
  }
  /** Solo muestra chips completos: mide cuántos caben de verdad, nunca corta el texto de uno a la mitad. */
  private actualizarChipsRegionVisibles(){
    setTimeout(() => {
      const seleccionadas = this.sucursalesSeleccionadas;
      const viewport = this.chipsRegionViewport?.nativeElement;
      if(!viewport || seleccionadas.length === 0){
        this.sucursalesChipsVisibles = [];
        this.hayMasSucursalesSeleccionadas = false;
        return;
      }
      const viewportWidth = viewport.offsetWidth;
      const visibles: any[] = [];
      let usedWidth = 0;
      for(let i = 0; i < seleccionadas.length; i++){
        const temp = document.createElement('div');
        temp.className = 'chipRegionCustom w3-elemento-menu';
        temp.style.position = 'absolute';
        temp.style.visibility = 'hidden';
        temp.innerText = seleccionadas[i].name;
        document.body.appendChild(temp);
        const chipWidth = temp.offsetWidth + 4;
        document.body.removeChild(temp);

        // El primero siempre se muestra (por si el contenedor aún no tiene ancho real).
        if(i === 0 || usedWidth + chipWidth <= viewportWidth){
          usedWidth += chipWidth;
          visibles.push(seleccionadas[i]);
        }else{
          break;
        }
      }
      this.sucursalesChipsVisibles = visibles;
      this.hayMasSucursalesSeleccionadas = visibles.length < seleccionadas.length;
    });
  }
  skeleton = true;
  subtitles = '';
  subtitles2 = '';
  expandAll = true;
  header: Header = {
    title: '',
  }

  // Criticidad fija por sucursal (no viene del backend). Regiones en blanco: en consulta.
  private readonly CRITICIDAD_POR_SUCURSAL: Record<number, string> = {
    1: 'Crítica', 2: 'Alta', 3: 'Crítica', 4: 'Crítica', 5: 'Alta', 6: 'Alta',
    10: 'Crítica', 14: 'Alta', 15: 'Alta', 16: 'Baja', 17: 'Crítica', 18: 'Baja',
    19: 'Crítica', 20: 'Alta', 21: 'Media', 22: 'Alta', 23: 'Media', 24: 'Crítica',
    25: 'Alta', 26: 'Crítica', 27: 'Crítica', 28: 'Alta', 29: 'Crítica', 31: 'Media',
    33: 'Crítica', 34: 'Crítica', 35: 'Alta', 36: 'Alta', 38: 'Baja', 39: 'Media',
    41: 'Crítica', 42: 'Crítica', 43: 'Crítica', 44: 'Crítica', 45: 'Crítica', 47: 'Media',
  };
  // Colores del semáforo del sistema (mismos que getIndicatorColor e indicadores-financieros).
  private readonly CRITICIDAD_COLORES: Record<string, string> = {
    'Crítica': '#FF495C',
    'Alta': '#FFC000',
    'Media': '#FFCB03',
    'Baja': '#72D54A',
  };
  periodoSelect = '';
  perspectives = [
    {
      name: 'General',
      check: true,
      encabezados: [0,1,2,3,4,5,6,7,8,9,10],
      tarjetas: [0,0,0,0,0],
      columns: [
        { title: 'PAR1', field: 'par1Indicator', limit: 5 },
        { title: 'PAR30', field: 'par30Indicator', limit: 2 },
        { title: 'PAR30+Refin', field: 'par30MasRefinIndicator', limit: 4 },
        { title: 'PAR60', field: 'par60Indicator', limit: 1 },
        { title: 'PAR90', field: 'par90Indicator', limit: 0.5 },
      ]
    },
    {
      name: 'PAR30 + Refinanciamientos',
      check: false,
      encabezados: [0,1,2,3,4,5,6,7,8],
      tarjetas: [0,0,0],
      columns: [
        { title: 'Saldo 1-30', field: 'saldoRefin1a30Indicator', limit: 0.3 },
        { title: 'Saldo 31-44', field: 'saldoRefin31a44Indicator', limit: 0.1 },
        { title: 'Saldo 45+', field: 'saldoRefin45Indicator', limit: 0.75 },
      ]
    },
    {
      name: 'Cosecha PAR1',
      check: false,
      encabezados: [0,1,2,3,4,5,6,7,8],
      tarjetas: [0,0,0],
      columns: [
        { title: '1-30', field: 'pCarteraCosecha1a30Indicator', limit: 0.5 },
        { title: '1-8', field: 'pCarteraCosecha1a8Indicator', limit: 0.05 },
        { title: '9-30', field: 'pCarteraCosecha9a30Indicator', limit: 0.45 },
      ]
    },
    {
      name: 'Castigos',
      check: false,
      encabezados: [0,1,2,3,4,5,6,7,8,9],
      tarjetas: [0,0,0,0],
      columns: [
        { title: '1-44', field: 'carteraMora1a44Indicator', limit: 2.8 },
        { title: '1-30', field: 'carteraMora1a30Indicator', limit: 2.6 },
        { title: '31-44', field: 'carteraMora31a44Indicator', limit: 0.2 },
        { title: '≥45 días', field: 'pCartera45Indicator', limit: 2 },
      ]
    },
  ];

  regiones = [];
  viewTabla = true;
  modal = false;

  typeGraphic = typesApex;
  type: typesApex;
  data = [];
  labels = [];
  etiquetasShow = true;
  tarjetasSkeleton = ['','','',''];
  @ViewChild('graficas') graficas: GraficadorComponent;

  modalTendencia = false;
  tendenciaType: typesApex = typesApex.LINE;
  tendenciaLabels: string[] = [];
  tendenciaData: any[] = [];
  tendenciaEtiquetasShow = true;
  tendenciaSkeleton = true;
  // Gama monocromática oficial (PropDiseno_Aleema_v08.pdf), misma que perfil.component.ts.
  paleta = ['#5EAEE5', '#8AD2E6', '#A4D55D', '#FFE370', '#FFAE5F', '#FB7598'];
  @ViewChild('graficaTendencia') graficaTendencia: GraficadorComponent;
  private tendenciaAnioCargado: string;
  private tendenciaPromediosPorMes: Record<string, number>[] = [];

  private token;
  private periodoInicial: any;
  constructor(
    public dataService: DataService,
    private readonly comercialService: ComercialService,
    private readonly translate: TranslateService,
    private excelService: ExcelService,
    private formaterPipe: FormaterNumberPipe,
  ){
    formatear.momentAbrev();
    this.getPeriods();
  }

  private async getPeriods(){
    const token = await firstValueFrom(this.comercialService.loginAleema());
    this.token = token['accessToken'];

    const periodos = await firstValueFrom(
      this.comercialService.getPeriodosAnexo1(this.token)
    );
    var auxYear = [];
    auxYear = this.comercialService.ordenarPeriodos(periodos['periods']).map(y => {
      return {
        anio: y.year,
        series: y.months.map(m => {
          return {
            mes: Meses.getMesesNumbertoString(m, true),
            mesS: Meses.getMesesNumbertoString(m, false),
            check: false,
            an: y.year,
            anio: (`${y.year}`).substring(2),
            periodo: Meses.getMesesNumbertoString(m, true)+' '+(`${y.year}`).substring(2),
            visible: true,
            utilizable: true,
          }
        }),
        visible: true,
        utilizable: true,
      }
    });

    const elegido = await this.comercialService.ultimoPeriodoConDatos(
      auxYear.flatMap(y => y.series),
      async periodo => {
        const r = await firstValueFrom(
          this.comercialService.getCreditoA1({
            perspective: PerspectiveIdentifier.REGION,
            period: periodo,
            granularity: PERIODICITY.MONTH
          }, this.token)
        );
        return r['results']?.length > 0;
      }
    );
    this.periodoInicial = elegido;
    elegido.check = true;
    this.periodos = auxYear;
    this.month = elegido.mesS;
    this.periodoSelect = elegido.periodo;

    const per = this.getPeriodo();
    const data = await firstValueFrom(
      this.comercialService.getCreditoA1({
        perspective: PerspectiveIdentifier.REGION,
        period: per,
        granularity: PERIODICITY.MONTH
      }, this.token)
    );
    const regionesDes = data['results'];
    const regiones = regionesDes.sort((a, b) => {
      if (a.description === 'SIN REGION') return 1;
      if (b.description === 'SIN REGION') return -1;

      return a.description.localeCompare(b.description, 'es', {
        sensitivity: 'base',
      });
    });
    this.sucursales = regiones.map(r => {
      return {
        description: formatear.capitalizar(r.description),
        name: formatear.capitalizar(r.description),
        check: true,
      }
    });
    
    this.getData();
    this.getTendencia();
  }
  private async getData(){
    this.skeleton = true;
    const per = this.getPeriodo();
    const data = await firstValueFrom(
      this.comercialService.getCreditoA1({
        perspective: PerspectiveIdentifier.REGION,
        period: per,
        granularity: PERIODICITY.MONTH
      }, this.token)
    );
    const regionesDes = data['results'];
    const regiones = regionesDes.sort((a, b) => {
      if (a.description === 'SIN REGION') return 1;
      if (b.description === 'SIN REGION') return -1;

      return a.description.localeCompare(b.description, 'es', {
        sensitivity: 'base',
      });
    });
    for(const r of regiones){
      const filters = {
        [PerspectiveIdentifier.REGION]: [r.code]
      }

      const sucursales = await firstValueFrom(
        this.comercialService.getCreditoA1({
          perspective: PerspectiveIdentifier.BRANCH_OFFICE,
          period: per,
          granularity: PERIODICITY.MONTH,
          filters
        }, this.token)
      );
      r['sucursales'] = sucursales['results'];
      r['sucursales'] = r['sucursales'].sort((a, b) =>
      a.description.localeCompare(b.description, 'es')
    );
      r['meta'] = r['goal'] ? { goal: r['goal'].carteraTotal } : null;
      r.description = formatear.capitalizar(r.description);
      r['sucursales'].forEach(s => {
        s.description = formatear.capitalizar(s.description);
        s['meta'] = s['goal'] ? { goal: s['goal'].carteraTotal } : null;
      });
      r['check'] = true;
      r['visible'] = true;
    }
    this.regiones = regiones;

    this.regiones.forEach(r =>{
      // Sin redondear: el promedio ponderado de recalcularData() necesita el valor completo.
      Object.keys(r.measures).forEach((key, i) => {
        if(key !== 'carteraTotal'){
          r.measures[key as keyof typeof r.measures]= r.measures[key as keyof typeof r.measures]*100;
        }
      });
      r.sucursales.forEach(s =>{
        Object.keys(s.measures).forEach((key) => {
          if(key !== 'carteraTotal'){
            s.measures[key as keyof typeof s.measures]= s.measures[key as keyof typeof s.measures]*100;
          }
        });
      });
    });
    this.recalcularData();
    this.skeleton = false;
  }
  /** Promedio consolidado por mes del año seleccionado; se cachea para no volver a consultar al cambiar de pestaña. */
  private async getTendencia(){
    const anioObj = this.periodos.find(y => y.series.some(m => m.check));
    if(!anioObj || anioObj.series.length === 0) return;

    const anioKey = `${anioObj.series[0].an}`;
    if(this.tendenciaAnioCargado === anioKey) return;

    this.tendenciaSkeleton = true;
    const promediosPorMes: Record<string, number>[] = [];
    const labels: string[] = [];

    for(const mes of anioObj.series){
      const periodo = `${mes.an}-${Meses.getMesesNum(mes.mes)}`;
      const data = await firstValueFrom(
        this.comercialService.getCreditoA1({
          perspective: PerspectiveIdentifier.REGION,
          period: periodo,
          granularity: PERIODICITY.MONTH
        }, this.token)
      );
      promediosPorMes.push(this.promediarMeasures(data['results']));
      labels.push(formatear.capitalizar(mes.mes));
    }

    this.tendenciaLabels = labels;
    this.tendenciaPromediosPorMes = promediosPorMes;
    this.tendenciaAnioCargado = anioKey;
    this.buildTendenciaSeries();
    this.tendenciaSkeleton = false;
  }
  /** Arma las series de la gráfica de tendencia a partir de la perspectiva (pestaña) activa. */
  private buildTendenciaSeries(){
    const per = this.perspectives.find(p => p.check);
    if(!per || this.tendenciaPromediosPorMes.length === 0){
      this.tendenciaData = [];
      return;
    }
    this.tendenciaData = per.columns.map(c => ({
      name: c.title,
      data: this.tendenciaPromediosPorMes.map(mes => mes[c.field] ?? 0)
    }));
  }
  /** Promedia todas las regiones ponderando por cartera, igual que recalcularData(). */
  private promediarMeasures(regiones: any[]): Record<string, number>{
    if(!regiones || regiones.length === 0) return {};
    const claves = Object.keys(regiones[0].measures);
    const sumas: Record<string, number> = {};
    claves.forEach(k => sumas[k] = 0);
    var sumaCartera = 0;
    regiones.forEach(r => {
      const cartera = r.measures['carteraTotal'];
      claves.forEach(k => {
        sumas[k] += k === 'carteraTotal' ? cartera : (r.measures[k] * 100) * cartera;
      });
      sumaCartera += cartera;
    });
    const promedio: Record<string, number> = {};
    claves.forEach(k => {
      promedio[k] = k === 'carteraTotal'
        ? Number(sumas[k].toFixed(2))
        : Number((sumaCartera ? sumas[k] / sumaCartera : 0).toFixed(2));
    });
    return promedio;
  }
  private recalcularData(){
    this.sucursales.forEach((s, i) =>{
        this.regiones[i].visible = s.check;
    });

    const claves = Object.keys(this.regiones[0].measures);
    const sumas: Record<string, number> = {};
    claves.forEach(k => sumas[k] = 0);
    var sumaCartera = 0;
    this.regiones.forEach(r =>{
      if(r.visible){
        const cartera = r.measures['carteraTotal' as keyof typeof r.measures] as number;
        claves.forEach(key => {
          // Promedio ponderado por cartera; carteraTotal en sí se deja como suma simple.
          sumas[key] += key === 'carteraTotal' ? cartera : r.measures[key as keyof typeof r.measures] * cartera;
        });
        sumaCartera += cartera;
      }
    });
    const promedio: Record<string, number> = {};
    claves.forEach(key => {
      promedio[key] = key === 'carteraTotal'
        ? Number(sumas[key].toFixed(2))
        : Number((sumas[key]/sumaCartera).toFixed(2));
    });
    this.perspectives.forEach(per => {
      per.tarjetas = per.columns.map(c => promedio[c.field] ?? 0);
    });
    this.getDataGrafica();
    this.getSubtitles();
  }
  private getDataGrafica(){
    var etiquetas = [], data = [];
    this.perspectives.forEach((p, i) => {
      if(p.check){
        etiquetas = p.columns.map( (c,p) => { 
          return this.translate.instant(`comercial.colocacion.anexo1.tabla${i+1}T${p+5}`)
        });
        data = p.columns.map( (c,p) => { 
          const act = this.regiones.filter(r => r.visible);
          if(act.length === 1){
            this.labels = act[0].sucursales.map(r => r.description);
            return act[0].sucursales.map(r => { return r.measures[c.field] })
          }else{
            this.labels = act.map(r => r.description);
            return act.map(r => { return r.measures[c.field] })
          }
        });
      }
    });

    this.data = [];
    etiquetas.forEach((e, p) =>{
      this.data.push({
        name: e,
        data: data[p]
      })
    });
  }

  yearChange(event){
    this.periodos.forEach( anio => {
      anio.series.forEach( per => {
        if(per.periodo === event.periodo){
          per.check = true;
          this.month = per.mesS;
          this.periodoSelect = per.periodo;
        }else{
          per.check = false;
        }
      });
    });
    this.expandAll = true;
    this.periodos = [...this.periodos];
    this.getData();
    this.getTendencia();
  }
  sucursalChange(sucClick){
    var sucursalesS = 0;
    for(const suc of this.sucursales){
      if(sucClick !== 'consolidado' && suc.name === sucClick.name){
        suc.check = !suc.check;
      }
      
      if(sucClick === 'consolidado'){
        suc.check = !this.selectAllSucursales;
      }
      if(suc.check){
        sucursalesS++;
      }
    }

    if(sucClick !== 'consolidado'){
      // Se apaga en cuanto deja de haber todas marcadas (antes solo se prendía).
      this.selectAllSucursales = sucursalesS === this.sucursales.length;
    }

    if(sucClick === 'consolidado'){
      this.selectAllSucursales = !this.selectAllSucursales;
    }
    this.sucursales = [...this.sucursales];
    if(sucursalesS !== 0) this.recalcularData();
    this.actualizarChipsRegionVisibles();
  }
  perspectiveChange(perClick){
    for( const suc of this.perspectives){
      if(suc.name === perClick.name){
        suc.check = true;
      }else{
        suc.check = false;
      }
    }
    this.perspectives = [...this.perspectives];
    this.getDataGrafica();
    this.buildTendenciaSeries();
  }
  private getPeriodo(){
    const an = this.periodos.find(y => y.series.find(m => m.check));
    const mes = an.series.find(m => m.check);

    return `${mes.an}-${Meses.getMesesNum(mes.mes)}`;
  }
  borrarFiltros(){
    this.perspectives.forEach((p,i) =>{
      i===0?p.check=true:p.check=false;
    });
    this.viewTabla = true;
    this.selectAllSucursales = true;
    this.sucursales.forEach(s =>{
        s.check = this.selectAllSucursales;
    })
    this.expandAll = true;
    this.etiquetasShow = true;
    this.yearChange(this.periodoInicial);
  }
  getIndicatorClass(value: number, limit: number): string {
    return value <= limit ? 'bordeVerde' : 'bordeRojo';
  }
  getIndicatorColor(value: number, limit: number): string {
    return value <= limit ? '#72D54A' : '#FF495C';
  }
  /** Criticidad fija de la sucursal; vacío para regiones. */
  getCriticidad(code: number): string {
    return this.CRITICIDAD_POR_SUCURSAL[code] ?? '';
  }
  /** Color de semáforo según el nivel de criticidad. */
  getCriticidadColor(nivel: string): string {
    return this.CRITICIDAD_COLORES[nivel] ?? '';
  }
  getCumplimiento(cartera: number, meta: number): number {
    return meta ? Number(((cartera / meta) * 100).toFixed(2)) : 0;
  }
  /** goal null = sin meta asignada (distinto de 0, que sí es válido); se muestra "—". */
  formatMeta(meta: {actual?: number; goal?: number} | null | undefined): string {
    if(!meta || meta.goal === null || meta.goal === undefined){
      return '—';
    }
    return this.formaterPipe.transform(meta.goal, 0, ',', '.');
  }
  getCumplimientoMeta(cartera: number, meta: {actual?: number; goal?: number} | null | undefined): string {
    if(!meta || meta.goal === null || meta.goal === undefined){
      return '—';
    }
    return this.formaterPipe.transform(this.getCumplimiento(cartera, meta.goal), 0, ',', '.') + '%';
  }
  getSubtitles(){
    this.subtitles = '';
    this.subtitles2 = '';
    this.header.chips = [];
    this.header.subtitles = [];

    const perS = this.perspectives.find(p => p.check);
    this.header.title = perS.name;
    this.header.subtitles = [{
      text: this.periodoSelect
    }];


    if(this.selectAllSucursales){
      const consolidado = this.translate.instant('comercial.colocacion.anexo1.consolidado');
      this.header.chips = [{
        text: consolidado
      }]
      this.subtitles = consolidado;
      this.subtitles2 = consolidado;
    }else{
      const select = this.sucursales.filter(s => s.check);
      select.forEach(s =>{
        this.header.chips.push({text: s.name});
      });
      this.subtitles = select.map(s => s.name).join(' | ');
      this.subtitles2 = this.subtitles;

      if(select.length === 1){
        this.subtitles2 += ` | ${this.translate.instant('filtros.sucursales')}`;
      }
    }
    this.header = {...this.header};
  }
  changeGraph(type){
    this.viewTabla = false;
    this.type = type;
  }
  changeGraphTendencia(type){
    this.tendenciaType = type;
  }
  expandirElements(elemento){
    if(elemento === 'consolidado'){
      this.expandAll = !this.expandAll;
      this.regiones.forEach(r =>{
        r.check = this.expandAll;
      });
    }else{
      const r = this.regiones.find(r => r.description === elemento.description);
      r.check = !r.check;

      const rS = this.regiones.filter(r => r.check);
      if(rS.length === 0){
        this.expandAll = false;
      }else{
        this.expandAll = true;
      }
    }
  }
  exportExcel(){
    const data = [];
    var headers = [], formatos = [], aligment = [], titulo = '', colors = [], filasResaltadas = [];
    this.perspectives.forEach( (per, posP) =>{
      if(per.check){
        titulo = per.name;
        headers = per.encabezados.map(e => this.translate.instant(`comercial.colocacion.anexo1.tabla${posP+1}T${e}`));
        headers = headers.slice(1);
        formatos = [
          FormatText.TEXT,
          FormatText.NUMBERDEC,
          FormatText.NUMBERDEC,
          FormatText.TEXT, // ya trae el %
          ...per.columns.map( e => FormatText.NUMBERDEC),
          FormatText.TEXT // Criticidad es texto, no número
        ]
        aligment = [
          Aligment.LEFT,
          Aligment.RIGHT,
          Aligment.RIGHT,
          Aligment.RIGHT,
          ...per.columns.map( e => Aligment.RIGHT),
          Aligment.RIGHT
        ]
        this.regiones.forEach((r, p) =>{
          if(r.visible){
            const aux = [], auxC = [];
            aux.push(r.description);
            aux.push(this.formatMeta(r.meta));
            aux.push(this.formaterPipe.transform(r.measures.carteraTotal,2,',','.'));
            aux.push(this.getCumplimientoMeta(r.measures.carteraTotal, r.meta));
            aux.push(
              ...per.columns.map( e => r.measures[e.field])
            )
            aux.push(''); // Criticidad: sin dato a nivel región por ahora
            data.push(aux);
            filasResaltadas.push(true); // región: negrita + gris
            auxC.push('');
            auxC.push('');
            auxC.push('');
            auxC.push('');
            auxC.push(
              ...per.columns.map( e => this.getIndicatorColor(r.measures[e.field],e.limit))
            )
            auxC.push('');
            colors.push(auxC);
            r.sucursales.forEach((s, p) =>{
              if(r.visible){
                const auxS = [], auxSC = [];
                auxS.push(s.description);
                auxS.push(this.formatMeta(s.meta));
                auxS.push(this.formaterPipe.transform(s.measures.carteraTotal,2,',','.'));
                auxS.push(this.getCumplimientoMeta(s.measures.carteraTotal, s.meta));
                auxS.push(
                  ...per.columns.map( ss => s.measures[ss.field])
                )
                auxS.push(this.getCriticidad(s.code));
                data.push(auxS);
                filasResaltadas.push(false);
                auxSC.push('');
                auxSC.push('');
                auxSC.push('');
                auxSC.push('');
                auxSC.push(
                  ...per.columns.map( ss => this.getIndicatorColor(s.measures[ss.field],ss.limit))
                )
                auxSC.push(this.getCriticidadColor(this.getCriticidad(s.code))); // Color lateral de Criticidad
                colors.push(auxSC);
              }
            });
          }
        });
      }
    });
    
    this.excelService.generateExcelSinTitulo(headers,data,titulo,aligment,formatos,colors,filasResaltadas);
  }
  exportImage(){
    const titulos = {
      titulo: this.perspectives.find(p => p.check).name,
      subtitulo: this.perspectives.find(p => p.check).name,
      nombreArch: this.perspectives.find(p => p.check).name
    };
    this.graficas.exportImg(1,titulos)
  }
  exportImageTendencia(){
    const nombrePerspectiva = this.perspectives.find(p => p.check).name;
    const titulos = {
      titulo: `Tendencia - ${nombrePerspectiva}`,
      subtitulo: this.periodoSelect,
      nombreArch: `Tendencia - ${nombrePerspectiva}`
    };
    this.graficaTendencia.exportImg(3,titulos)
  }
}